// extracted by mini-css-extract-plugin
module.exports = {"spotify-playlist-embed":"spotify-playlist-embed_spotify-playlist-embed__GWbGf","spotify-playlist-embed__iframe":"spotify-playlist-embed_spotify-playlist-embed__iframe__IJgyG"};